export const OVERVIEW_EVENT_TYPE = {
  CLASS: 'class',
  PRIVATE_LESSON: 'private_lesson',
} as const;

export type OverviewEventType =
  (typeof OVERVIEW_EVENT_TYPE)[keyof typeof OVERVIEW_EVENT_TYPE];

export interface OverviewEvent {
  classId: string;
  className: string;
  instructorName: string;
  startMinutes: number;
  endMinutes: number;
  locationName?: string;
  roomId: string;
  color: string;
  type?: OverviewEventType;
  bookingId?: string;
  studentName?: string;
}

export interface PositionedOverviewEvent {
  event: OverviewEvent;
  leftPx: number;
  widthPx: number;
}

export interface RoomRowData {
  roomId: string;
  roomName: string;
  locationName?: string;
  classCount: number;
  lanes: Array<Array<PositionedOverviewEvent>>;
}

export interface InstructorOption {
  label: string;
  value: string;
}

export const ALL_INSTRUCTORS_OPTION: InstructorOption = {
  label: 'All',
  value: '__all__',
};

export const UNASSIGNED_ROOM_ID = '__unassigned__';
